import React from "react";
import { MainPage } from "../modules/Fees";

export function FeesPage(props) {
  return <MainPage {...props} />;
}
